import React from "react"
import MobileDetect from "mobile-detect";
import {detect} from "detect-browser";
import SuperAgent from "superagent"
import thankyou from "../components/thankyou"
import css from "../css"

const isNode = typeof document === 'undefined';

if (css) require('./contact-form.scss')

const state = {
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    desc: "",
}

class ContactForm extends React.Component {
    submit() {
        const md = new MobileDetect(window.navigator.userAgent);
        const checkDevice = () => md.mobile() || md.tablet() 
        const checkBrowser = () => {
            const browser = detect()
            return !!browser && browser.name 
        }        
        const submit = {
            source: 'contact',
            email: state.email,
            firstname: state.firstname,
            lastname: state.lastname,
            phone: state.phone,
            job: "",
			country: "",
            city: "",
          region: "",
          company:"",
			path: isNode ? "" : window.location.pathname,
            device:checkDevice() || 'desktop', 
            browser:checkBrowser(),
            ga: !!window[window['GoogleAnalyticsObject'] || 'ga'],
            items: JSON.stringify([]),
            description: state.desc
        }
        SuperAgent
            .post('/api/lead')
            .set('Content-Type', 'application/x-www-form-urlencoded')  // required for PHP's $_POST
            .send(submit)
            .end(thankyou)
    }
    render() {
        return (
            <form id="form" className="pg-contact-form"
                  onSubmit={(e) => {
                    e.preventDefault()
                    this.submit()
                  }}>
              <div className="pg-contact-form-title">
                <h2>Start the conversation</h2>
                <h3>Fill out the 10-second form below</h3>
              </div>
              <div className="pg-contact-form-fields">
                <div className="pg-contact-form-row">
                  <div className="splitForm">
                    <div className="input">
                      <label htmlFor="firstname">First Name</label>
                      <div>
                        <input type="text" name="firstname" id="firstname" placeholder="First Name" required
                               value={state.firstname}
                               onChange={(e) => {
                                   state.firstname = e.target.value
                                   this.forceUpdate()
                               }}
                        />
                      </div>
                    </div>
                    <div className="input">
                      <label htmlFor="lastname">Last Name</label>
                      <div>
                        <input type="text" name="lastname" id="lastname" placeholder="Last Name" required
                               value={state.lastname}
                               onChange={(e) => {
                                   state.lastname = e.target.value
                                   this.forceUpdate()
                               }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="pg-contact-form-row">
                  <div className="fullForm">
                    <div className="input">
                      <label htmlFor="email">Email</label>
                      <div>
                        <input type="email" name="email" id="email" placeholder="Your Email" required
                               value={state.email}
                               onChange={(e) => {
                                   state.email = e.target.value
                                   this.forceUpdate()
                               }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="pg-contact-form-row">
                  <div className="fullForm">
                    <div className="input">
                      <label htmlFor="phone">Phone number</label>
                      <div>
                        <input type="text" name="phone" id="phone" placeholder="Your company phone number" required
                               value={state.phone}
                               onChange={(e) => {
                                   state.phone = e.target.value
                                   this.forceUpdate()
                               }}/>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="pg-contact-form-row">
                  <div className="fullForm">
                    <div className="input">
                      <label htmlFor="desc">Your project</label>
                      <div>
                        <textarea name="desc" id="desc" placeholder="Tell us about your project..."
                               value={state.desc}
                               onChange={(e) => {
                                   state.desc = e.target.value
                                   this.forceUpdate()
                               }} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="pg-contact-form-row">
                  <button className="pg-contact-form-submit">{this.props.submit}</button>
                </div>
              </div>
            </form>
        ) 
    }
}

module.exports = ContactForm



// WEBPACK FOOTER //
// ./src/forms/contact-form.jsx